import React from "react";
import { Wheel } from "react-custom-roulette";
import { WheelContainer, OuterBadge, SpinButton, } from "../SpinHome.style";
import { StartIcon } from '@assets'
import { t } from "i18next";

const textColors = ['#ffffff', '#ffffff', '#120e08', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'];
const backgroundColors = ['#ca3d77', '#fba629', '#f3f3e9', '#2faf74', '#e65051', '#fba629', '#2faf74', '#39a1e8'];

// const textColors = ["#342309"];
// const backgroundColors = ["#fffcf3", "#fd1615"];


const props = {
	textColors,
	backgroundColors,
	fontFamily: "Libre Franklin",
	fontWeight: 'bolder',
	fontSize: 22,
	radiusLineWidth: 0,
	outerBorderWidth: 0,
	innerBorderColor: "#FFA500",
	innerBorderWidth: 6,
	innerRadius: 0,
	textDistance: 67,
};

const SpinWheel = ({
	handleSpinClicked,
	started,
	winningIndex,
	spinValues,
	handleStop,
}) => {
	return (
		<div
			style={{
				position: "relative",
			}}
		>
			<WheelContainer>
				<Wheel
					disableInitialAnimation={true}
					mustStartSpinning={started}
					prizeNumber={winningIndex}
					data={spinValues}
					onStopSpinning={handleStop}
					{...props}
				/>
				<OuterBadge  />
			</WheelContainer>
      <SpinButton onClick={handleSpinClicked}> {t("spin.start")} <StartIcon /> </SpinButton>
		</div>
	);
};

export default SpinWheel;
